<template>
    <section 
        id="service-section" 
        class="mx-10 md:mx-20 lg:mx-25 my-20 py-20 px-2 md:px-16 rounded-3xl text-center" 
        :class="context.isDarkMode ? 'bg-semidark-silver' : 'bg-void'"

    >
        <i class="pi pi-flag text-center text-white w-full mb-5 text-8 xl:text-12"></i>
        <h2 class="text-4xl xl:text-2xl 2xl:text-4xl font-bold mb-20 md:mb-0 text-center translate-text" :class="context.isDarkMode ? 'text-silver' : 'text-silver'">
            {{ translationHandler.translate('our services', 'capitalize') }}
        </h2>
        
        <div class="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6 gap-2">
            <div 
                class="
                    p-6 rounded-3xl shadow-lg flex flex-col cursor-pointer 
                    hover:bg-third-color transition-colors
                    mb-20 md:mb-0
                    trigger-service-el
                "
                v-for="(service, index) of services"
                :key="index"
            >
                <img :src="service.image" class="mx-auto rounded-3xl enlarge-top-effect" :alt="service.title + ' image'" />
                <h3 class="text-2xl font-semibold text-white mt-10 mb-2">
                    {{ translationHandler.translate(service.title, 'capitalize') }}
                </h3>
                <p class="text-main-gray mt-2 translate-text">
                    {{ translationHandler.translate(service.description, 'ucfirst') }}
                </p>
            </div>
        </div>
    </section>
</template>

<script setup>

import { useContextStore } from '@/stores/context';
import translationHandler from '@/composables/handlers/TranslationHandler';
import { onMounted, ref } from 'vue';
import AnimationHandler from '@/composables/handlers/AnimationHandler';

const context = useContextStore();

const services = ref([
    {
        title: 'web development',
        description: 'modern and responsive websites for companies and professionals.',
        icon: 'pi pi-desktop',
        image: require('@/assets/images/website-card.png')
    },
    {
        title: 'e-commerce',
        description: 'complete and optimized virtual stores for online sales.',
        icon: 'pi pi-desktop',
        image: require('@/assets/images/ecommerce-card.png')
    },
    {
        title: 'web systems',
        description: 'customized solutions to optimize your business processes.',
        icon: 'pi pi-desktop',
        image: require('@/assets/images/webapp-card.png')
    },
    {
        title: 'api integrations',
        description: 'we connect systems efficiently, ensuring secure and automated communication between platforms to optimize your processes.',
        icon: 'pi pi-desktop',
        image: require('@/assets/images/api-card.png')
    },
    {
        title: 'automation and bots',
        description: 'we create intelligent bots for repetitive tasks, improving productivity and reducing manual errors in various workflows.',
        icon: 'pi pi-desktop',
        image: require('@/assets/images/automation-card.png')
    },
    {
        title: 'web scrapping and robots',
        description: 'we extract web data accurately and in a structured manner, turning scattered information into valuable insights for your business.',
        icon: 'pi pi-desktop',
        image: require('@/assets/images/robot-card.png')
    },
]);

onMounted(() => {
    handleAnimation();
});

async function handleAnimation() {
    const data = [
        {
            mainClass: 'trigger-service-el',
            classesToUse: ['bg-third-color'],
            startInterval: 100,
            intervalPerAction: 200,
            triggerAt: '#service-section'
        }
    ];
    (new AnimationHandler(data)).watchScrollAndAnimate();

}

</script>